<template>
  <modal :show="show" @close="close">
    <div id="location-delete-modal" slot="header" class="modal-header">
      <h5 class="modal-title">Delete Location</h5>
      <button type="button" class="close" @click="close(false)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">Are you sure you want to delete the location "{{ locationIP }}"?</div>

    <template v-slot:footer>
      <button id="location-delete-cancel" class="btn btn-light" @click="close(false)">No</button>
      <button id="location-delete-confirm" class="btn btn-primary" @click="deleteLocation">Yes</button>
    </template>
  </modal>
</template>

<script>
import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";
import Modal from "@/components/Modal";

export default {
  name: "DeleteLocationModal",
  props: ["show", "ip"],
  components: {
    Modal
  },
  computed: {
    locationIP() {
      return this.ip;
    }
  },
  methods: {
    close(success) {
      this.$emit("close", success);
    },
    async deleteLocation() {
      try {
        await CoreAPI.deleteLocation(this.ip);
        this.close(true);
      } catch (error) {
        if (error.isNetworkError) {
          this.error = modals.lostConnectionText;
        } else {
          this.error = modals.unexpectedErrorText;
        }
      }
    }
  }
};
</script>
